export enum Themes {
  THEME_1 = '1',
  THEME_2 = '2',
  THEME_3 = '3',
  THEME_4 = '4',
  THEME_5 = '5',
  THEME_6 = '6',
  THEME_7 = '7',
  THEME_8 = '8',
  THEME_9 = '9',
  THEME_10 = '10',
  THEME_11 = '11',
  THEME_12 = '12'
}

export type Theme = {
  [key in Themes]: { primary: string; secondary: string; colorName: string };
};

export const themeList: Theme = {
  [Themes.THEME_1]: {
    primary: '#80aeff',
    secondary: '#4b5c70',
    colorName: 'BLUE'
  },
  [Themes.THEME_2]: {
    primary: '#FFDC92',
    secondary: '#33312e',
    colorName: 'GRANDIS'
  },
  [Themes.THEME_3]: {
    primary: '#11cccc',
    secondary: '#264444',
    colorName: 'AQUA'
  },
  [Themes.THEME_4]: {
    primary: '#22ecae',
    secondary: '#4b5c70',
    colorName: 'TURQUOISE'
  },
  [Themes.THEME_5]: {
    primary: '#9a92ff',
    secondary: '#4b5c70',
    colorName: 'MELROSE'
  },
  [Themes.THEME_6]: {
    primary: '#f08080',
    secondary: '#4b5c70',
    colorName: 'CORAL'
  },
  [Themes.THEME_7]: {
    primary: '#ffa07a',
    secondary: '#4b5c70',
    colorName: 'SALMON'
  },
  [Themes.THEME_8]: {
    primary: '#00cfdd',
    secondary: '#4b5c70',
    colorName: 'RE-BLUE'
  },
  [Themes.THEME_9]: {
    primary: '#00c79e',
    secondary: '#4b5c70',
    colorName: 'GREEN'
  },
  [Themes.THEME_10]: {
    primary: '#0086c7',
    secondary: '#4b5c70',
    colorName: 'LOCHMARA'
  },
  [Themes.THEME_11]: {
    primary: '#a46eec',
    secondary: '#4b5c70',
    colorName: 'PURPLE'
  },
  [Themes.THEME_12]: {
    primary: '#F285B9',
    secondary: '#4b5c70',
    colorName: 'VIOLET'
  }
};
export const themeArray: Array<{
  key: string;
  value: { primary: string; secondary: string; colorName: string };
}> = Object.keys(themeList).map(_ => ({
  key: _ as Themes,
  value: themeList[_ as Themes]
}));
